<template>
  <v-app-bar app color="#0e1f43" style="height:96px !important;z-index: 9" id="top">
    <div class="content">
      <div class="imge"></div>
      <div class="show-responsive-menu" @click="showMenu=true">
        <v-icon color="#ffffff">menu</v-icon>
      </div>
      <div class="show_menu" @click="showMenu=true">
        <v-icon color="#ffffff" style="font-size: 38px;opacity: .5;">account_circle</v-icon>
        <label
          style="margin: 8px 10px 0px 10px;font-size: 15px;color:white;cursor:pointer"
        >{{usuario.first_name}} {{usuario.first_surname}}</label>
        <v-menu
          offset-y
          origin="center center"
          offset-x
          left
          bottom
          :nudge-bottom="5"
          :nudge-right="0"
          :close-on-content-click="false"
          :nudge-width="300"
          transition="scale-transition"
          v-model="showMenu"
          content-class="modalMenu"
        >
          <template v-slot:activator="{ on }">
            <v-icon color="white" v-on="on">arrow_drop_down</v-icon>
          </template>

          <v-card class="card_popver">
            <div class="title_popover">
              <div class="left_img">
                <v-icon style="font-size: 48px;">account_circle</v-icon>
              </div>
              <div class="right_content">
                <div class="upper_content">{{usuario.first_name}} {{usuario.first_surname}}</div>
                <div class="lower_content">{{usuario.email}}</div>
                <!-- <div class="blue_link" style="font-size:12px;margin-top:10px">Datos de perfil</div> -->
              </div>
            </div>
            <div class="grayline"></div>
            <!-- <div class="progress_text">Progreso de mis cursos</div> -->

            <!-- <div class="idiom_content">
              <div class="flex_content">
                <img src="./../assets/images/united-kingdom-flag-round.svg" alt />
                <div style="margin-left:5px;font-size:12px;color:#666666">Ingles</div>
              </div>
              <div class="text_left">25%</div>
            </div>
            <div>
              <v-progress-linear
                style="margin-top:10px;border-radius: 7.5px;"
                background-color="#D8D8D8"
                color="#00ABE7"
                value="25"
                height="12"
              ></v-progress-linear>
            </div>

            <div class="idiom_content">
              <div class="flex_content">
                <img src="./../assets/images/brazil-flag-round.svg" alt />
                <div style="margin-left:5px;font-size:12px;color:#666666">Brasil</div>
              </div>
              <div class="text_left">60%</div>
            </div>
            <div>
              <v-progress-linear
                style="margin-top:10px;border-radius: 7.5px;"
                background-color="#D8D8D8"
                color="#00ABE7"
                value="60"
                height="12"
              ></v-progress-linear>
            </div>-->

            <!-- <div class="grayline"></div>
            <div class="progress_text">Quiero aprender un nuevo idioma</div>
            <div class="grayline"></div>
            <div class="progress_text">Historial de pagos</div>
            <div class="grayline"></div>-->
            <div class="text_blue" style="font-size:12px;margin:15px 0" @click="cerrarSesion">
              <span style="padding: 5px 0px;cursor:pointer">Cerrar sesión</span>
            </div>
          </v-card>
        </v-menu>
      </div>
    </div>
  </v-app-bar>
</template>
<script>
export default {
  name: "AppToolbar",
  components: {
    // VuePerfectScrollbar
    // NotificationList
  },
  data() {
    return {
      usuario: null,
      showMenu: false
    };
  },
  watch: {},
  created() {
    this.usuario = this.$store.state.usuario;
  },
  computed: {},
  methods: {
    cerrarSesion() {
      this.$store.dispatch("salir");
    }
  }
};
</script>

<style lang="scss">
@import "./../assets/styles/todo";
@import "./../assets/styles/responsiveness";
.v-toolbar {
  box-shadow: none !important;
}
.v-toolbar__content {
  height: 96px !important;
}
.content {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  padding: 0 130px;
  align-content: center;
  height: 100%;
  align-items: center;
  .imge {
    background-image: url(./../assets/images/LOGO_450x100.svg);
    background-size: cover;
    width: 330px;
    height: 70px;
  }
  .show_menu {
    display: flex;
    flex-direction: row;
    cursor: pointer;
  }
}
</style>
